/* eslint-disable @typescript-eslint/no-unused-vars */
import { Button, Modal, Typography } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import useStyles from 'components/molecules/PredictionGrid/components/ModalVariation/style';
import { IModalVariationProps } from 'components/molecules/PredictionGrid/components/ModalVariation/types';
import { IGridVariationData } from 'interfaces/Grid';
import React, { useMemo } from 'react';

import { useQuery } from 'react-query';
import { postGridVariation } from 'services/prediction/grid-chromatographic';

function ModalVariation({
  children,
  onClose,
  open,
  gridRow,
}: IModalVariationProps) {
  const classes = useStyles();
  const [gridData, setGridData] = React.useState<IGridVariationData[]>([]);

  const columns = useMemo(() => {
    return [
      'Coleta',
      'Nº de séries',
      'TAG',
      'H2',
      'O2',
      'N2',
      'CO2',
      'C2H4',
      'C2H6',
      'C2H2',
      'CO',
      'CH4',
      'TGC',
    ];
  }, []);

  const idsAnalysis = useMemo(() => {
    return gridRow.map(item => {
      return item.id;
    });
  }, [gridRow]);

  const enableQueryVariation = useMemo<boolean>(() => {
    return open && idsAnalysis?.length === 2;
  }, [open, idsAnalysis]);

  // eslint-disable-next-line no-unused-vars
  const queryVariation = useQuery({
    queryKey: [`VariationGridContext`],
    queryFn: async () => {
      const params = {
        idsAnalysis,
      };
      const { data } = await postGridVariation(params);
      return data;
    },
    onSuccess: data => {
      setGridData(data);
    },
    enabled: enableQueryVariation,
    cacheTime: 0,
  });

  const renderTable = React.useCallback(() => {
    return (
      <div className={classes.mainTable}>
        <table className={classes.borderStyle}>
          <tr className={classes.tableHeader}>
            {columns.map(item => {
              return <th className={classes.alignTh}>{item}</th>;
            })}
          </tr>
          <tr className={classes.tableRow}>
            {Object.values(gridData).map(item => {
              return <td>{item || '0'}</td>;
            })}
          </tr>
        </table>
      </div>
    );
  }, [gridData, columns, classes]);

  const body = (
    <div className={classes.modal}>
      <div className={classes.modalHeader}>
        <Typography variant="subtitle1" className={classes.headerTitle}>
          Variação (%)
        </Typography>
        <Close className={classes.headerIcon} onClick={onClose} />
      </div>
      <div>{renderTable()}</div>
      <div className={classes.modalFooter}>
        <Button onClick={() => onClose()} color="primary">
          Fechar
        </Button>
      </div>
    </div>
  );

  return (
    <>
      {children}
      <div className={classes.container}>
        <Modal open={open} onClose={onClose}>
          {body}
        </Modal>
      </div>
    </>
  );
}

export default ModalVariation;
